module.exports = __webpack_public_path__ + "static/media/jinit_sanghvi.a36d1476.jpg";